/* LeParfin V5 : avis (filtre par parfum + « Voir plus d'avis »), liste d'ingrédients raccourcie sur mobile,
   liens qui ouvrent un accordéon (#composition-complete), formulaire de contact (focus du message, double envoi).
   Sans dépendance ; chargé en defer par les sections qui en ont besoin. Sans JavaScript, tout reste lisible. */
(() => {
  'use strict';
  if (window.__lpV5) return;
  window.__lpV5 = true;

  const all = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const hashKey = () => { try { return decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return ''; } };

  /* ---------- Avis : [data-lp-rv] (data-rv-first, data-rv-step), items [data-rv][data-k], filtres [data-rv-filter] ---------- */
  function reviews(root) {
    if (!root || root.__lpRv) return;
    root.__lpRv = true;
    const items = all('[data-rv]', root);
    if (!items.length) return;
    const chips = all('[data-rv-filter]', root);
    const more = root.querySelector('[data-rv-more]');
    const rest = more && more.querySelector('[data-rv-rest]');
    const empty = root.querySelector('[data-rv-empty]');
    const first = parseInt(root.getAttribute('data-rv-first'), 10) || 3;
    const step = parseInt(root.getAttribute('data-rv-step'), 10) || 6;
    let key = 'tous';
    let limit = first;
    /* V3.11 : tri « Les mieux notés » (data-o, ordre par défaut) / « Les plus récents » (data-r). */
    const sorts = all('[data-rv-sort]', root);
    sorts.forEach(b => b.addEventListener('click', () => {
      const attr = b.getAttribute('data-rv-sort') === 'r' ? 'data-r' : 'data-o';
      const box = items[0].parentNode;
      items.sort((a, c) => (+a.getAttribute(attr) || 0) - (+c.getAttribute(attr) || 0));
      items.forEach(it => box.appendChild(it));
      sorts.forEach(x => { const on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      limit = first;
      render();
    }));

    const matches = () => items.filter(it => key === 'tous' || it.getAttribute('data-k') === key);

    function render(focusIndex) {
      const list = matches();
      items.forEach(it => { if (!list.includes(it)) it.hidden = true; });
      list.forEach((it, i) => { it.hidden = i >= limit; });
      const left = Math.max(0, list.length - limit);
      if (more) {
        more.hidden = left === 0;
        if (rest) rest.textContent = '(' + left + ')';
      }
      if (empty) empty.hidden = list.length > 0;
      if (typeof focusIndex === 'number' && list[focusIndex]) {
        const el = list[focusIndex];
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
      }
    }

    function select(k, fromUser) {
      const chip = chips.find(c => c.getAttribute('data-rv-filter') === k) || chips[0];
      key = chip ? chip.getAttribute('data-rv-filter') : 'tous';
      limit = first;
      chips.forEach(c => {
        const on = c === chip;
        c.classList.toggle('on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      render();
      if (fromUser && root.hasAttribute('data-rv-hash') && window.history && window.history.replaceState) {
        const url = key === 'tous' ? window.location.pathname + window.location.search : '#' + encodeURIComponent(key);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    if (more) {
      more.addEventListener('click', () => {
        const from = limit;
        limit += step;
        render(from);
      });
    }
    chips.forEach(c => c.addEventListener('click', () => select(c.getAttribute('data-rv-filter'), true)));

    const known = k => chips.some(c => c.getAttribute('data-rv-filter') === k);
    if (chips.length && root.hasAttribute('data-rv-hash')) {
      const h = hashKey();
      select(known(h) ? h : 'tous', false);
      window.addEventListener('hashchange', () => { const k = hashKey(); if (known(k)) select(k, false); });
    } else {
      render();
    }
  }

  /* ---------- Liste d'ingrédients : raccourcie sur mobile, bouton [data-ing-more] ---------- */
  function ingredients(root) {
    if (!root || root.__lpIng) return;
    root.__lpIng = true;
    const btn = root.parentElement && root.parentElement.querySelector('[data-ing-more]');
    const rows = root.children.length;
    if (!btn || rows <= 5) return;
    const openLabel = btn.textContent;
    const lessLabel = btn.getAttribute('data-less') || openLabel;
    root.classList.add('is-short');
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const open = root.classList.toggle('is-short') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? lessLabel : openLabel;
      if (open && root.children[5]) {
        const el = root.children[5];
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
      }
    });
  }

  /* ---------- Liens vers un accordéon : ouvre le <details> ciblé ---------- */
  function openDetails(id) {
    if (!id) return;
    const el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS') el.open = true;
  }
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[data-open-details]');
    if (!a) return;
    const id = (a.getAttribute('href') || '').replace(/^#/, '');
    openDetails(id);
  });

  /* ---------- Formulaire de contact ---------- */
  function contact(form) {
    if (!form || form.__lpCf) return;
    form.__lpCf = true;
    const status = form.querySelector('[data-cf-status]');
    if (status) {
      form.scrollIntoView({ block: 'start' });
      status.focus({ preventScroll: true });
    }
    form.addEventListener('submit', () => {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); window.setTimeout(() => { btn.disabled = true; }, 0); }
    });
  }

  function init(scope) {
    const s = scope || document;
    all('[data-lp-rv]', s).forEach(reviews);
    all('[data-ing-list]', s).forEach(ingredients);
    all('form.lp-cf-form', s).forEach(contact);
    const h = hashKey();
    if (h) openDetails(h);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
